module.exports = __webpack_public_path__ + "img/aicon11.1cd589be.png";